<template>
    <!--    <div><dx-button @click="openSelectBankpolPopup" text="Выбор банка получателя" /></div>-->
    <ai-grid-edit-wrapper
        ref="gridRef"
        :meta="meta"
        :args="args"
        :action="action"
        @gridEditWrapperMounted="onGridEditWrapperMounted"
    />
    <!--    <dx-popup :visible="selectBankpolPopup">-->
    <!--        <div style="height: 90%">-->
    <!--            <component :is="componentName" ref="bankpolRef" />-->

    <!--            <dx-button text="выбрать" @click="onBankpolSelected" />-->
    <!--            <dx-button text="закрыть" @click="selectBankpolPopup = false" />-->
    <!--        </div>-->
    <!--    </dx-popup>-->
</template>

<script setup>
// import aiGridEditWrapper from '@/components/wrappers/ai-grid-edit-wrapper.vue';
// import { DxButton, DxPopup } from 'devextreme-vue';
import { ref } from 'vue';
// import { mainState } from '@/layouts/main-layout/main-layout-data';

// onMounted(async () => {
//     if (mainState.isReload) await gridRef.value.setCacheOrApiDataSource();
//     gridRef.value.gridInstance.option('focusedRowIndex', 0);
// });

// watch(
//     () => mainState.routePath,
//     async () => {
//         await gridRef.value.setCacheOrApiDataSource();
//     }
// );

const emit = defineEmits(['gridEditWrapperMounted']);

const onGridEditWrapperMounted = () => {
    emit('gridEditWrapperMounted');
};

defineProps({
    action: {
        type: Function,
        default: null,
    },
});

// const componentName = ref();
const gridRef = ref();
// const bankpolRef = ref();
// const selectBankpolPopup = ref(false);

const meta = {
    keyExpr: 'kod_ist',
    title: 'Источники финансирования',
    columns: [
        {
            name: 'kod_ist',
            caption: 'kod_ist',
            dataField: 'kod_ist',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 1,
            visible: false,
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 2,
            visible: true,
        },
        {
            name: 'name_bank',
            caption: 'Банк получателя (по умолчанию)',
            dataField: 'name_bank',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 6,
            visible: false,
        },
        {
            name: 'ocher',
            caption: 'ocher',
            dataField: 'ocher',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 150,
            index: 3,
            visible: false,
        },
        {
            name: 'kodbpol_teplo',
            caption: 'kodbpol_teplo',
            dataField: 'kodbpol_teplo',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 4,
            visible: false,
        },
        {
            name: 'npp',
            caption: 'npp',
            dataField: 'npp',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 5,
            visible: false,
        },
    ],
    api: {
        select: 'nsi./nsi/view-ks-istfin/select/get',
        save: 'nsi./nsi/view-ks-istfin/save/set',
    },
    viewId: 'view-ks-istfin',
};
const args = {};

// const onBankpolSelected = async () => {
//     console.log(bankpolRef.value.focusedRow);
// };
// const openSelectBankpolPopup = () => {
//     selectBankpolPopup.value = true;
//     componentName.value = 'ks-bankpol-view';
//     console.log(gridRef.value.ref.gridInstance.option('focusedRowKey'));
// };

defineExpose({
    componentRef: gridRef,
});
</script>

<script>
export default {
    name: 'ks-istfin-view',
};
</script>

<style scoped></style>
